<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="600px">
    <template v-slot:title>Export List</template>
    <v-row v-if="exporting" justify="center" align="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="purple"
        indeterminate
      ></v-progress-circular>
    </v-row>
    <v-row v-else>
      <v-col>
        <v-select
          v-model="format"
          item-value="value"
          item-text="text"
          :items="visibleFormats"
          label="Format"
          :outlined="outlinedInputs"
        ></v-select>
        <v-row v-if="resultURL != ''" justify="center">
          <v-btn @click="onDownload"
            ><v-icon left>mdi-download</v-icon> Download
            <v-icon right>{{ formatIcon }}</v-icon></v-btn
          >
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col v-if="setAsExported">
        <v-switch v-model="exported" label="Set as Exported"></v-switch>
      </v-col>
      <v-col v-if="showGroupBySupplier">
        <v-switch v-model="groupBySupplier" label="Group bySupplier"></v-switch>
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn
        color="primary"
        :loading="exporting"
        @click="onExport"
        :disabled="format == ''"
        >Generate</v-btn
      >
    </template>
    <div v-if="debug">
      <code>{{ showSage }}</code>
    </div>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../BasicDialog";
import gql from "graphql-tag";
import { TASK_STATUS_QUERY } from "../../../../constants/graphql";
const CREATE_EXPORT_MUTATION = gql`
  mutation exportList($input: ListExportInput!) {
    createListExport(input: $input) {
      id
      status
      notes
    }
  }
`;
export default {
  name: "list-export",
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    records: {
      type: Array,
      default: () => [],
    },
    list: {
      type: String,
      default: () => "",
    },
    filter: {
      type: Object,
      default: () => {},
    },
    customFilter: {
      type: Object,
      default: () => {},
    },
    setAsExported: {
      type: Boolean,
      default: () => true,
    },
    showSage: {
      type: Boolean,
      default: () => false,
    },
    customFormats: {
      type: Array,
      default: () => [],
    },
  },

  components: { BasicDialog },

  data() {
    return {
      debug: false,
      exporting: false,
      resultURL: "",
      format: "CSV",
      exported: this.$store.getters.hasAccessTo("finances:export_flag_enabled"),
      formats: [
        { text: "XLSX", value: "XLSX" },
        { text: "CSV", value: "CSV" },
        { text: "HTML", value: "HTML" },
        { text: "PDF", value: "PDF" },
        ...(this.customFormats.length > 0 ? this.customFormats : []),
      ],
      checkStatus: false,
      taskID: "",
      //additional settings
      groupBySupplier: false,
    };
  },

  computed: {
    visibleFormats() {
      return this.showSage
        ? [...this.formats, { text: "SAGE CSV", value: "SAGE_CSV" }]
        : [...this.formats];
    },
    showGroupBySupplier() {
      return (
        this.list == "purchaseInvoices" &&
        (this.format == "HTML" || this.format == "PDF")
      );
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    formatIcon() {
      const icons = {
        XLSX: "mdi-file-excel-box",
        CSV: "mdi-file-delimited",
        PDF: "mdi-pdf-box",
        HTML: "mdi-language-html5",
        SAGE_CSV: "mdi-file-delimited",
      };
      return icons[this.format];
    },
  },

  methods: {
    async onExport() {
      //this.$emit("export", { format: this.format });
      //this.exporting = true;
      const exportInput = {
        name: this.list,
        format: this.format,
        recordsIds: this.records.map((r) => (r.node ? r.node.id : r.id)),
        columns: this.columns,
        filter: JSON.stringify({ ...this.filter, ...this.customFilter }),
        options: JSON.stringify({ groupBySupplier: this.groupBySupplier }),
        setAsExported: this.exported,
      };

      try {
        const { data } = await this.$apollo.mutate({
          mutation: CREATE_EXPORT_MUTATION,
          variables: {
            input: { ...exportInput },
          },
        });
        this.exporting = true;
        this.taskID = data.createListExport.id;
        console.log(data.createListExport);
        this.checkStatus = true;
      } catch (error) {
        console.error(error);
      }
    },
    onDownload() {
      window.open(this.resultURL, "_blank");
    },
  },
  apollo: {
    taskStatus: {
      query: TASK_STATUS_QUERY,
      variables: function () {
        return { taskId: this.taskID };
      },
      result({ data, loader, networkStatus }) {
        this.checkStatus = false;
        if (data.taskStatus.status == "IN_PROGRESS") {
          setTimeout(() => {
            this.checkStatus = true;
          }, 2000);
        } else {
          this.exporting = false;
          //console.log(data.taskStatus);
          this.$emit("complete", data.taskStatus);
          if (data.taskStatus.status == "ERROR") {
            this.$store.dispatch("showAppSnackbar", {
              msg: data.taskStatus.notes,
              color: "error",
            });
          } else {
            this.resultURL = data.taskStatus.notes;
          }
        }
        //console.log('status',data.generateDocumentStatus.status);
      },
      skip() {
        return !this.checkStatus;
      },
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/list-actions/ListExport.vue